import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { OverlayContainer } from '@react-aria/overlays';
import { forwardRef } from 'react';
/**
 * A {@link Popover} is a type of **atom** that represents a
 * non-semantic container intended to float above, or popover,
 * the document.
 */
const Popover = forwardRef(({ children, className, ...rest }, ref) => {
    return (_jsx(OverlayContainer, { children: _jsx("div", { className: buildClassName('rounded-lg bg-white focus:border-none', className), ref: ref, ...rest, children: children }) }));
});
export default Popover;
//# sourceMappingURL=Popover.js.map